import { UITSCANNER_TEXT } from "../i18n/uitscanner.js";

export default function BlockingOverlay({
  open,
  message,
  onClose,
  lang = "nl",
  title,
  closeLabel,
  topOffset,
}) {
  const t = UITSCANNER_TEXT[lang] || UITSCANNER_TEXT.nl;

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255,0,0,0.10)",
        zIndex: 9999,
        backdropFilter: "blur(1px)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: topOffset || "10px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "#fff",
          border: "3px solid #ff3b30",
          color: "#b00020",
          padding: "16px 20px",
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,.2)",
          maxWidth: 480,
          width: "90%",
          textAlign: "center",
          fontWeight: 600,
        }}
      >
        <div style={{ fontSize: 22, marginBottom: 6 }}>
          {title || t.warning}
        </div>

        <div style={{ fontSize: 18, whiteSpace: "pre-line" }}>{message}</div>

        <button
          onClick={onClose}
          style={{
            marginTop: 14,
            padding: "8px 14px",
            borderRadius: 8,
            border: "1px solid #ddd",
            cursor: "pointer",
            background: "#fff",
          }}
        >
          {closeLabel || t.closing}
        </button>
      </div>
    </div>
  );
}
